import script from "./Patient_VariantDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./Patient_VariantDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__